import { useAdminCheck } from '@/hooks/useAdminCheck';
import { FEATURE_FLAGS, useFeatures } from '@/hooks/useFeatures';

/**
 * Whether the current user may create matters. When the tenant enables
 * `only_admins_can_create_matters`, only tenant admins can. Non-admins are
 * denied until the flag has loaded, so the control never shows for a
 * restricted tenant.
 */
export const useCanCreateMatter = (): boolean => {
  const { featureMap } = useFeatures();
  const { isAdmin } = useAdminCheck();
  if (isAdmin) return true;
  const restriction = featureMap[FEATURE_FLAGS.ONLY_ADMINS_CAN_CREATE_MATTERS];
  return restriction !== undefined && !restriction.enabled;
};
